import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { LoaderEffects } from './loader.effects';
import { loaderReducer } from './loader.reducer';

@NgModule({
    declarations: [],
    imports: [CommonModule, StoreModule.forFeature('loader', loaderReducer), EffectsModule.forFeature([LoaderEffects])],
    exports: [],
    providers: [],
})
export class LoaderStateModule {}
